import useFilterParams from "@/hooks/useFilterParams";
import { ALL_RESULTS_DATE_FILTERS } from "@/views/MentionsView/MentionLayout/ranges";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@components/ui/empty";
import { Trans } from "@lingui/react/macro";
import { Button } from "@components/ui/button";

export default function EmptyTimePeriod() {
  const [{ tag }, setFilters] = useFilterParams();

  return (
    <Empty data-testid="empty-period-no-mentions">
      <EmptyHeader>
        <EmptyMedia></EmptyMedia>
        <EmptyTitle>
          <Trans>Inga omnämnanden</Trans>
        </EmptyTitle>
        <EmptyDescription>
          <Trans>Det finns inga träffar under vald period.</Trans>
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button
          variant="outline"
          onClick={(e: unknown) => {
            (e as MouseEvent).preventDefault();
            setFilters({ tag, ...ALL_RESULTS_DATE_FILTERS }, true);
          }}
        >
          <Trans>Visa alla</Trans>
        </Button>
      </EmptyContent>
    </Empty>
  );
}
